import React from "react";
import styled from "styled-components";
import { Colors, TextFont } from "../../config";
import { FlexWithGap } from "./LoginStyledComponents";

const SuccessPageContainer = ({ header, subheader, imgSrc, tagline }) => {
  return (
    <SuccessPageContainerWrapper>
      <FlexWithGap gap="0.5rem">
        <TextFont
          fontColor={Colors.white}
          fontWeight="500"
          fontSize="2.5rem"
          maxWidth="500px"
          respFontSize="2rem"
        >
          {header}
        </TextFont>
        <SubheaderWrapper>
          <TextFont
            fontColor={Colors.white}
            fontWeight="300"
            fontSize="1.375rem"
            maxWidth="500px"
            respFontSize="1rem"
          >
            {subheader}
          </TextFont>
        </SubheaderWrapper>
      </FlexWithGap>
      <ImgRespSuccess src={imgSrc} alt="success" />
      <TextFont
        fontColor={Colors.white}
        fontWeight="300"
        fontSize="1.375rem"
        maxWidth="500px"
        respFontSize="1rem"
      >
        {tagline}
      </TextFont>
    </SuccessPageContainerWrapper>
  );
};

export default SuccessPageContainer;

const SuccessPageContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  height: 100%;
  justify-content: space-evenly;
`;
const SubheaderWrapper = styled.div`
  max-width: 25.5rem;
`;
const ImgRespSuccess = styled.img`
  max-width: 80%;
  height: auto;
`;
